import { mySqlToLocal } from '@helpers'
import dayjs from "dayjs"
const advancedFormat = require("dayjs/plugin/advancedFormat")
dayjs.extend(advancedFormat);

const getSessionDateRange = (startsAt, endsAt, dateFormat = "dddd Do of MMMM") => {
  const starts = mySqlToLocal(startsAt)
  const ends = mySqlToLocal(endsAt)

  return starts.format(dateFormat) + " " + starts.format('HH:mm') + " - " + ends.format('HH:mm')
}

export default getSessionDateRange